var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-8" },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", justify: "center" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "d-flex justify-center mt-3",
              attrs: { sm3: "", md3: "" }
            },
            [
              _c("v-avatar", { attrs: { color: "pink", size: "115" } }, [
                _c("span", { staticClass: "white--text display-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        !!_vm.contact.lastName && !!_vm.contact.name
                          ? _vm.contact.lastName[0].toUpperCase() +
                              _vm.contact.name[0].toUpperCase()
                          : ""
                      ) +
                      " "
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm9: "", md9: "" } },
            [
              _c(
                "v-row",
                { staticClass: "mb-n3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-left",
                      staticStyle: { "word-break": "break-word" },
                      attrs: { cols: "12" }
                    },
                    [
                      _c("h1", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.displayContactNames(
                                _vm.contact.lastName,
                                _vm.contact.name
                              )
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-row mt-n4",
                      attrs: { cols: "12" }
                    },
                    [
                      !!_vm.contact.ci
                        ? _c(
                            "h2",
                            { staticClass: "font-weight-regular mt-1" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    !!_vm.contact.ci
                                      ? _vm.displayContactCI(_vm.contact.ci)
                                      : ""
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.isDaycohostUser || _vm.isCustomerManagement
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "userStatusChip ml-3 ma-2",
                              staticStyle: { "font-size": "125%" },
                              attrs: {
                                color: _vm.displayUserStatusColor(
                                  _vm.contact.userStatus.name
                                ),
                                dark: "",
                                label: ""
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.displayUserStatus(
                                    _vm.contact.userStatus.name
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Nombres")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              staticStyle: { "word-break": "break-word" },
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.name ? _vm.contact.name : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              staticStyle: { "word-break": "break-word" },
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Apellidos")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.lastName
                      ? _vm.contact.lastName
                      : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Cédula de Identidad")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.ci
                      ? _vm.displayContactCI(_vm.contact.ci)
                      : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c("v-col", { attrs: { cols: "6", lg: "3" } }),
          _c("v-col", { attrs: { cols: "4" } }, [_c("v-divider")], 1)
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.contact.userId === -1
                    ? "Correo Electrónico"
                    : "Correo Electrónico"
                )
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left breakCharacters",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.email
                      ? !_vm.isDaycohostUser ||
                        _vm.isCustomerManagement ||
                        _vm.contact.userId === -1
                        ? _vm.contact.email
                        : _vm.contact.email +
                          " / " +
                          _vm.displayUsername(_vm.contact.email)
                      : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Teléfono Primario")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.phone ? _vm.contact.phone : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      !_vm.isDaycohostUser || _vm.isCustomerManagement
        ? _c(
            "v-row",
            { staticClass: "mb-n3" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-row-reverse font-weight-bold",
                  attrs: { cols: "6", lg: "3" }
                },
                [_vm._v("Télefono Secundario")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-left",
                  attrs: { cols: "6", lg: "9" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.contact.cellphone
                          ? _vm.contact.cellphone
                          : "No especificado"
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c("v-col", { attrs: { cols: "6", lg: "3" } }),
          _c("v-col", { attrs: { cols: "4" } }, [_c("v-divider")], 1)
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Tipo de Contacto")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.contact.contactTypeName
                      ? _vm.contact.contactTypeName
                      : "No especificado"
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Cargo")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [
              _c("span", { staticClass: "position" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.contact.position
                        ? _vm.contact.position
                        : "No especificado"
                    ) +
                    " "
                )
              ]),
              _vm.contact.scalabilityLevelName &&
              _vm.contact.scalabilityLevelName !== ""
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "scalability-level-name pl-1"
                                      },
                                      "span",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          " | " +
                                            _vm.contact.scalabilityLevelName
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2093867822
                      )
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "scalability-level-desc d-inline-block"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.contact.scalabilityLevelDescription) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-n3" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row-reverse font-weight-bold",
              attrs: { cols: "6", lg: "3" }
            },
            [_vm._v("Privilegios")]
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-left",
              attrs: { cols: "6", lg: "9" }
            },
            [_vm._v(" " + _vm._s(_vm.contactPrivileges) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }